<h3 [innerHTML]="motivesDescriptionText.heading"></h3>
<div [innerHTML]="motivesDescriptionText.mainText" class="id37-text2 text-light"></div>
